<template>
  <div class="header-parent">
    <v-container>
      <v-row>
        <v-col cols="12" md="8" class="pa-0">
          <header>
            <v-col sm="12" class="responsive-pad">
              <div class="padded">
                <h1>Pour s'entrainer chez nous.<v-spacer /> c'est simple !</h1>
              </div>
              <p>
                Nous vous proposons des solutions de coaching sportif, des
                <br />
                programmes d'entrainement en Live, de la téléconsultation et des
                <br />
                solutions d'analyse pour atteindre tous vos objectifs de remise
                en
                <br />
                forme en toute efficacité!
              </p>
              <a
                href="/register"
                class="btnHeader"
                title="Inscrivez-vous et vivez l'expérience"
              >
                Inscrivez-vous et vivez l'expérience
              </a>
            </v-col>
          </header>
        </v-col>
        <v-col cols="12" md="4" class="pl-0 pb-0">
          <section>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube-nocookie.com/embed/iXqlQhQQIj8?controls=0&showinfo=0&rel=0"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </section>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Header",
  components: {},
  data: () => ({
    links: [{ text: "Home", to: "/" }],
  }),
};
</script>

<style scoped>
@import url("./../../assets/css/main-css.css");
.header-parent {
  background: url("./../../assets/images/landing.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.container {
  padding: 0px;
}
header {
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  width: 100%;
}
section {
  align-items: center;
  height: calc(100vh - 70px);
  display: flex;
}
.padded {
  border-left: 12px solid #e91e24;
}
header h1 {
  font-weight: 800;
  font-size: 50px;
  line-height: 1.1;
  color: #fff;
  text-transform: uppercase;
  position: relative;
  left: 20px;
}
header p {
  font-family: "Hind Siliguri", sans-serif;
  color: #fff;
  font-size: 17px;
  display: block;
  margin: 25px 0;
  opacity: 0.75;
}
header .btnHeader {
  border: 1px solid #e91e24;
  color: #fff;
  background: #e91e24;
  border-radius: 3px;
  padding: 10px 25px;
  display: inline-block;
  text-decoration: none;
  font-size: 17px;
}
@media (max-width: 768px) {
  header {
    background-repeat: no-repeat;
    background-position: 90% 20px;
    background-size: contain;
    display: block;
    padding-top: 20px;
  }
  .responsive-pad {
    padding: 25px 45px;
  }
  header h1 {
    font-size: 35px;
    letter-spacing: 1px;
  }
  header p {
    font-size: 15px;
    text-align: justify;
    display: block;
    margin-top: 15px;
  }
}
</style>